import axios from 'axios';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { SaleSum } from 'types/sale';
import { BASE_URL } from 'utils/requests';

type ChartData = {
  labels: string[];
  series: number[];
}

const DonutChart = () => {
  const options = {
    legend: {
      show: true
    }
  }

  const [isLoad, setIsLoad] = useState(false);
  const [chartData, setChartData] = useState<ChartData>({} as ChartData);

  useEffect(() => {
    async function loadData() {
      const response = await axios.get(`${BASE_URL}/sales/amount-by-seller`);
      const data = response.data as SaleSum[];

      const series = data.map(item => item.sum);
      const labels = data.map(item => item.sellerName);

      setChartData({
        labels,
        series
      });

      setIsLoad(true);
    }

    loadData();
  }, []);

  return (
    <>
    {
      isLoad && (
        <Chart
          type="donut"
          height={240}
          series={chartData.series}
          options={{ ...options, labels: chartData.labels }}
        />
      )
    }
    </>

  )
}

export default DonutChart;
